var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaret(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_210",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 15
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 15,
    width: 14,
    height: 15,
    transform: "rotate(-180 14 15)",
    fill: "#E86046"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_210)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.67708 1.8125L13.5917 7.0625C13.65 7.125 13.6913 7.19271 13.7156 7.26562C13.7399 7.33854 13.7521 7.41667 13.7521 7.5C13.7521 7.58333 13.7399 7.66146 13.7156 7.73437C13.6913 7.80729 13.65 7.875 13.5917 7.9375L8.67708 13.2031C8.54096 13.349 8.37083 13.4219 8.16666 13.4219C7.96249 13.4219 7.78749 13.3437 7.64166 13.1875C7.49583 13.0312 7.42291 12.849 7.42291 12.6406C7.42291 12.4323 7.49583 12.25 7.64166 12.0937L11.9292 7.5L7.64166 2.90625C7.50555 2.76041 7.43749 2.58073 7.43749 2.36719C7.43749 2.15364 7.51041 1.96875 7.65624 1.8125C7.80208 1.65625 7.97222 1.57812 8.16666 1.57812C8.3611 1.57812 8.53124 1.65625 8.67708 1.8125Z",
    fill: "#FB2648"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaret);
export default __webpack_public_path__ + "static/media/caret.18c13f7b795af627265541f446b65616.svg";
export { ForwardRef as ReactComponent };